/**
 * 判断是否为移动设备
 * @returns {boolean}
 */
export function getIsMobile() {
  console.log(window.navigator.userAgent, 'isMobileisMobileisMobileisMobile');
  const ua = window.navigator.userAgent.toLowerCase();
  const mobileAgents = [
    'android',
    'iphone',
    'ipod',
    'ipad',
    'windows phone',
    'mqqbrowser',
    'micromessenger',
  ];

  // 检查是否包含移动设备标识
  const isMobileDevice = mobileAgents.some((agent) => ua.includes(agent));

  // 检查屏幕宽度（可选，作为辅助判断）
  const isSmallScreen = window.innerWidth <= 768;

  return isSmallScreen || isMobileDevice;
}

/**
 * 判断是否为PC设备
 * @returns {boolean}
 */
export function isPC() {
  return !isMobile();
}
